import styles from '../mna-info.module.scss';
import classnames from 'classnames/bind';
import React, {useState} from "react";
import {Form, Formik} from "formik";
import {toast} from "react-toastify";
import {CustomerMnaNeedsDto} from "../../../model/customer/dto/customer-mna-needs-dto";
import {useInjection} from "inversify-react";
import {CustomerInputApi} from "../../../model/customer/customer-input-api";
import {CustomerApi} from "../../../model/customer/customer-api";
import {DialogManager} from "../../../components/dialog-manager";
import {CustomerMnaNeedsForm} from "../../../model/customer/form/customer-mna-needs-form";
import MnaIntroductionFeePolicyPop from "./mna-introduction-fee-policy-pop";
import {alertComment, isShowTempSaveBtn, MnaInfoProp, needsBtnTitle} from "../mna-info";
import {MnATypeList} from "../../../data/const_list";
import {TextAreaBox} from "./company-type-form";
import NeedsCustomerType from "./needs-customer-type";
import NeedsSaveBtn from "./needs-save-btn";

const cx = classnames.bind(styles);

const AcquireNeedsForm = ({data, needs, setNeeds, needsType, setNeedsType, available} : MnaInfoProp) => {
    const customerInputApi = useInjection(CustomerInputApi);
    const customerApi = useInjection(CustomerApi);
    const dialogManager = useInjection(DialogManager);
    const [isDraft, setIsDraft] = useState(false);

    if (!needs) return <div></div>;

    const acq = needs.acq;

    const saveExcel = async (type: string) => {
        const shareMemberNo = data.share && data.share.srcMember.memberNo;
        const loadResult = await customerInputApi.excelMnaNeeds(data.customer!.id, shareMemberNo ?? "", type);

        if (loadResult.success) {
            window.location.href = customerApi.makeDownloadFile(loadResult.data!);
        } else {
            if (loadResult.message == "NoData") {
                dialogManager.alert("M&A 니즈 정보를 저장 후 다시 시도해주십시오.");
            } else {
                dialogManager.alert("상담시트 인쇄에 실패했습니다.");
            }
        }
    }

    return(
        <Formik
            initialValues={{
                companyType: needsType,
                isTempSave: needs.isTempSave,
                acq: acq,
            }}
            onSubmit={async (values) => {

                const form: CustomerMnaNeedsForm = {
                    shareMemberNo: data.share ? data.share.srcMember.memberNo : "",
                    isTempSave: values.isTempSave,
                    enpNm: data.customer?.enpNm ?? "",
                    ceoName: data.customer?.rep[0].name ?? "",
                    type: needsType,
                    acq: values.acq,
                };

                const type = MnATypeList.find(it => it.id === values.companyType)?.title ?? '';

                if(isDraft) {
                    form.isTempSave = true;
                    form.isApplyNeeds = false;

                    const result = await customerInputApi.updateMnaNeeds(data.customer!.id, form);

                    if (result.success) {
                        toast.success('임시 저장되었습니다.');

                        const dto: CustomerMnaNeedsDto = {
                            id: data.customer!.id,
                            isTempSave: form.isTempSave,
                            isApplyNeeds: form.isApplyNeeds,
                            type: form.type,
                            brokerage: form.brokerage,
                            acq: form.acq,
                            createAt: needs.createAt
                        }

                        data.customer!.companyInfo.mainProduct = form.brokerage?.mainProduct;

                        setNeeds(dto);
                    } else {
                        toast.error("임시 저장에 실패했습니다.");
                    }
                } else {
                    const reqMsgTitle = alertComment(needs, needsType) ? `${type} 기업으로 등록하시겠어요?` : `저장하시겠습니까?`;

                    const reqMsgContent = alertComment(needs, needsType) ? '중개신청이 완료되면, 씨오M&A센터에서\n1영업일 이내 연락드립니다.' : '';

                    const cancelBtn = alertComment(needs, needsType) ? undefined : '취소';

                    dialogManager.confirm(reqMsgTitle, reqMsgContent, async () => {
                        form.isTempSave = false;
                        form.isApplyNeeds = true;

                        const result = await customerInputApi.updateMnaNeeds(data.customer!.id, form);

                        if (result.success) {
                            const msg = ((needs.isTempSave === null || needs.isTempSave)  && !form.isTempSave) ? "등록이 완료되었습니다." : "저장되었습니다.";
                            dialogManager.alert(msg);

                            const dto: CustomerMnaNeedsDto = {
                                id: data.customer!.id,
                                type: form.type,
                                acq: form.acq,
                                createAt: needs.createAt
                            }

                            setNeeds((prevNeeds) => ({
                                ...prevNeeds,
                                id: dto.id,
                                type: dto.type,
                                acq: dto.acq,
                                isTempSave: form.isTempSave,
                                isApplyNeeds: form.isApplyNeeds,
                                createAt: dto.createAt
                            }));
                        } else {
                            dialogManager.alert(result.message ?? "등록에 실패했습니다.");
                        }
                    }, undefined, undefined, undefined, cancelBtn);
                }

            }}>
            {({values}) =>

                <div className={cx('mna-info')}>
                    <Form>
                        <div className={cx('title-line')}>
                            <p className={cx('title')}>
                                M&A 니즈
                                <button className={cx('status-btn')} type='button' onClick={() => {
                                    dialogManager.open(MnaIntroductionFeePolicyPop, {})
                                }}>M&A 소개수수료 정책<i></i></button>
                            </p>
                            <div className={cx('btn-area')}>
                                <button className={cx('print-btn')} type='button'
                                        onClick={() => saveExcel(values.companyType)}><i></i>상담시트 인쇄
                                </button>
                                <NeedsSaveBtn needs={needs} needsType={needsType} setIsDraft={setIsDraft}/>
                                {/*{(needs.isTempSave === null || needs.isTempSave) && <button className={cx('temporary-save-btn')} type='submit'*/}
                                {/*        onClick={() => setIsDraft(true)}>임시 저장하기*/}
                                {/*</button>}*/}
                                {/*<button className={cx('save-btn')} type='submit' onClick={() => setIsDraft(false)}>*/}
                                {/*    <i></i>{`${(needs.isTempSave !== null && !needs.isTempSave) ? "저장하기" : "등록하기"}`}*/}
                                {/*</button>*/}
                            </div>
                        </div>
                        <div className={cx('content')}>
                            <NeedsCustomerType needs={needs} needsType={needsType} setNeedsType={setNeedsType} available={available} />
                            <div className={cx('company-type-form')}>
                                <TextAreaBox title='1. 인수기업 주요 제품' name={'acq.mainProduct'}/>
                                <TextAreaBox
                                    title='2. 인수기업 사업영역'
                                    name='acq.bizAreaInfo'
                                    initialH='15rem'/>
                                <TextAreaBox
                                    title='3. M&A 목적'
                                    name='acq.mnaPurpose'
                                    initialH='15rem'/>
                                <TextAreaBox
                                    title='4. 기존 인수경험'
                                    name='acq.experAcq'
                                    initialH='15rem'/>
                                <p className={cx('separate-label')}>5. 희망인수조건</p>
                                <TextAreaBox
                                    title='1) 주요서비스 / 사업영역'
                                    name='acq.acqHopeTerms.acqTerms1'
                                    isInnerTitle={true}
                                    initialH='15rem'/>
                                <TextAreaBox
                                    title='2) 매출액 / 영업이익'
                                    name='acq.acqHopeTerms.acqTerms2'
                                    isInnerTitle={true}/>
                                <TextAreaBox
                                    title='3) 경영기간 / 근로자수 / 지역'
                                    name='acq.acqHopeTerms.acqTerms3'
                                    isInnerTitle={true}/>
                                <TextAreaBox
                                    title='4) 연구소 및 기업인증 / 특허 및 기술'
                                    name='acq.acqHopeTerms.acqTerms4'
                                    isInnerTitle={true}/>
                                <TextAreaBox
                                    title='5) 공장보유 여부'
                                    name='acq.acqHopeTerms.acqTerms5'
                                    isInnerTitle={true}/>
                                <TextAreaBox
                                    title='6) 기타조건'
                                    name='acq.acqHopeTerms.acqTerms6'
                                    isInnerTitle={true}/>
                                <div className={cx('btn-area')}>
                                    {isShowTempSaveBtn(needs, needsType) && <button className={cx('temporary-save-btn')} type='submit'
                                            onClick={() => setIsDraft(true)}>임시 저장하기
                                    </button>}
                                    <button className={cx('save-btn')} type='submit' onClick={() => setIsDraft(false)}>
                                        <i></i>{`${needsBtnTitle(needs, needsType)}`}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            }
        </Formik>
    );
}

export default AcquireNeedsForm;